e.inputs = {
	init : function(){
		$( 'form' ).on( 'submit', this._handle_required_fields );
	},

	_handle_required_fields : function( ev ){
		var $form = $( this );
		var $inputs = $form.find( '[data-required="true"]' );
		for( i = 0; i < $inputs.length; i++ ){
			var $_input = $( $inputs[i] );
			if( $_input.val() == '' || $_input.val() == 0 ){
				$_input.addClass( 'error' );
				e.fn.show_tip( $_input, $_input.data( 'required-message' ) );
				ev.preventDefault();
				$( 'body,html' ).animate( {
					scrollTop : $_input.offset().top
				});
				return false;
			}
		}
	}
};